import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Divider,
  Avatar,
  Menu,
  MenuItem,
  useMediaQuery
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useAuth } from "../context/AuthContext"; 
import logo from "../assets/images/CWA_logo.png";

const Header = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:900px)");
  const { user, logout } = useAuth(); 

  const [openDrawer, setOpenDrawer] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const toggleDrawer = (state) => () => {
    setOpenDrawer(state);
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const navLinks = [
    { title: "HOME", path: "/" },
    { title: "ABOUT US", path: "/aboutus" },
    { title: "OUR PEOPLE", path: "/our-people" },
    { title: "LEADERSHIP", path: "/leadership" },
    { title: "GALLERY", path: "/gallery" }
  ];

  const handleNavigation = (path) => {
    if (path === "/our-people") {
      if (window.location.pathname === "/") {
        const section = document.getElementById("our-people-section");
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      } else {
        navigate("/");
        setTimeout(() => {
          const section = document.getElementById("our-people-section");
          if (section) {
            section.scrollIntoView({ behavior: "smooth" });
          }
        }, 500);
      }
    } else {
      navigate(path);
    }
    setOpenDrawer(false);
  };

  return (
    <AppBar position="static" sx={{ backgroundColor: "#FAD707" }}>
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        {/* Logo */}
        <Box>
          <img src={logo} alt="Temple Logo" style={{ width: "140px", height: "auto" }} />
        </Box>

        {/* Desktop Navigation */}
        {!isMobile && (
          <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "center", gap: 3 }}>
            {navLinks.map((link, index) => (
              <Typography
                key={index}
                variant="h6"
                sx={{ textDecoration: "none", color: "black", fontWeight: 600, cursor: "pointer" }}
                onClick={() => handleNavigation(link.path)}
              >
                {link.title}
              </Typography>
            ))}
          </Box>
        )}
      {/* User Profile Dropdown OR Login/Register Buttons */}
        {user ? (
          <>
            <IconButton onClick={handleMenuOpen} color="inherit">
              {user?.firstName ? (
                <Avatar sx={{ bgcolor: "#E52029", color: "white" }}>
                  {user.firstName.charAt(0).toUpperCase()}
                </Avatar>
              ) : (
                <AccountCircleIcon sx={{ color: "#000000", fontSize: 30 }} />
              )}
              <ArrowDropDownIcon sx={{ color: "#E52029", fontSize: 30, marginLeft: "5px" }} />
            </IconButton>
            <Menu 
              anchorEl={anchorEl} 
              open={Boolean(anchorEl)} 
              onClose={handleMenuClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              
              <MenuItem onClick={() => {navigate("/profile"); handleMenuClose();}}>My Profile</MenuItem>
              <MenuItem onClick={() => {navigate("/membership");handleMenuClose();}}>Membership ID</MenuItem>
              {user?.role === "superuser" && (<MenuItem onClick={() => { navigate("/manageusers"); handleMenuClose();}}> Manage Users </MenuItem> )}
              {user?.role === "admin" && (<MenuItem onClick={() => { navigate("/manageuser"); handleMenuClose();}}> Manage Users </MenuItem>)}
              {user?.role === "superuser" && (<MenuItem onClick={() => {handleMenuClose();}}>Tally export data</MenuItem>)}
              {user?.role === "admin" && (<MenuItem onClick={() => {handleMenuClose();}}>Tally export data</MenuItem>)}
              <MenuItem onClick={handleMenuClose}>Receipt</MenuItem>
              <MenuItem onClick={() => {logout(); setAnchorEl(null); navigate("/login"); window.location.reload();}} >Logout </MenuItem>
               </Menu>
          </>
        ) : (
          !isMobile && (
            <Box sx={{ display: "flex", gap: 2 }}>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#E52029", "&:hover": { backgroundColor: "green" } }}
                onClick={() => navigate("/register")}
              >
                New Member
              </Button>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#E52029", "&:hover": { backgroundColor: "green" } }}
                onClick={() => navigate("/login")}
              >
                Registered Users
              </Button>
            </Box>
          )
        )}

        
                {/* Mobile Menu Button */}
        {isMobile && !user && (
          <IconButton onClick={toggleDrawer(true)} sx={{ color: "black" }}>
            <MenuIcon />
          </IconButton>
        )}
      </Toolbar>
      {/* Mobile Drawer (Side Menu) */}
      <Drawer anchor="left" open={openDrawer} onClose={toggleDrawer(false)}>
        <Box sx={{ width: 250, padding: 2 }}>
          {/* Close Button */}
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <img src={logo} alt="Temple Logo" style={{ width: "100px", height: "auto" }} />
            <IconButton onClick={toggleDrawer(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
          <List>
            {navLinks.map((link, index) => (
              <ListItem button key={index} onClick={() => handleNavigation(link.path)}>
                <ListItemText primary={link.title} />
              </ListItem>
            ))}
          </List>
          <Divider />
          {user ? (
            <List>
              <ListItem button onClick={() => navigate("/profile")}>
                <ListItemText primary="My Profile" />
              </ListItem>
              <ListItem button onClick={() => navigate("/membership")}>
                <ListItemText primary="Membership ID" />
              </ListItem>
              <ListItem button onClick={logout}>
                <ListItemText primary="Logout" />
              </ListItem>
            </List>
) : (
            <List>
              <ListItem button onClick={() => handleNavigation("/register")}>
  <ListItemText primary="NEW MEMBER" />
</ListItem>
<ListItem button onClick={() => handleNavigation("/login")}>
  <ListItemText primary="REGISTERED USERS" />
</ListItem>
            </List>
          )}
        </Box>
      </Drawer>
    </AppBar>
  );
};
export default Header;